import React from 'react'

const EmailViewUI = ({context, messageList, email}) =>
  <div>
    {email}
  </div>

export default EmailViewUI
